export class Plan {

    public relations = [];

    public names = {
        // therapist_id: function (data) {
        //     // return data.address && data.address.offname;
        // },
    }
}
